import { createStyles, Text } from "@mantine/core";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuthContext } from "../stores/auth-store";
import arc from "../assets/img/arc.png";
const useStyles = createStyles((theme) => ({
  loginLogo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: theme.other.arc.paddings[2],
    ".logo": { width: "auto", height: theme.other.imageHeight.lg },
  },
  login: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
}));
export const LoginOIDC = () => {
  const auth = useAuthContext();
  const navigateTo = useNavigate();
  const { classes } = useStyles();

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigateTo("/main");
    }
  }, [auth.isLoading, auth.isAuthenticated]);
  return (
    <div className={classes.login}>
      <div className={classes.loginLogo}>
        <img className="logo" src={arc} data-src={arc} data-src-retina={arc} alt="Arc360" />
      </div>
      <h2>Logging In</h2>
      <Text>Please wait while we setup your session</Text>
    </div>
  );
};
